<template>
  <ul>
    <template v-for="item in filteredMenu" :key="item.tittle">
      <li class="submenu-open">
        <h6 class="submenu-hdr">{{ item.tittle }}</h6>
        <ul>
          <template v-for="menu in item.menu" :key="menu.menuValue">
            <li
              v-if="!menu.hasSubRoute"
              :class="{ active: $route.path === menu.route }"
            >
              <router-link
                v-if="menu.route"
                :to="menu.route"
                @click="handleNavClick"
              >
                <vue-feather :type="menu.icon"></vue-feather>
                <span>{{ menu.menuValue }} </span>
              </router-link>
            </li>
            <li v-else :class="{ submenu: true, subdrop: menu.showSubRoute }">
              <a
                href="javascript:void(0)"
                :class="{
                  subdrop: menu.showSubRoute,
                  active: isMenuActive(menu),
                }"
                @click="expandSubMenus(menu)"
              >
                <vue-feather :type="menu.icon"></vue-feather>
                <span>{{ menu.menuValue }}</span>
                <span class="menu-arrow"></span>
              </a>
              <ul
                class="submenu-list"
                :class="{ show: menu.showSubRoute }"
              >
                <template v-for="subMenu in menu.subMenus" :key="subMenu.id">
                  <li :class="{ active: currentPath === subMenu.active_link }">
                    <router-link
                      :to="subMenu.route"
                      class="sub-active"
                      :class="{
                        'router-link-active': $route.path === subMenu.route,
                      }"
                      @click="handleNavClick"
                    >
                      {{ subMenu.menuValue }}
                    </router-link>
                  </li>
                </template>
              </ul>
            </li>
            <li v-if="menu.hasSubRouteTwo" class="submenu">
              <a
                href="javascript:void(0);"
                @click="openMenu(menu)"
                :class="{
                  subdrop: openMenuItem === menu,
                  active: isMenuActive(menu),
                }"
              >
                <vue-feather :type="menu.icon"></vue-feather
                ><span>{{ menu.menuValue }}</span>
                <span class="menu-arrow"></span>
              </a>
              <ul
                class="submenu-list"
                :class="{ show: openMenuItem === menu }"
              >
                <li v-for="subMenus in menu.subMenus" :key="subMenus.menuValue">
                  <template v-if="!subMenus.customSubmenuTwo">
                    <router-link :to="subMenus.route" @click="handleNavClick">{{
                      subMenus.menuValue
                    }}</router-link>
                  </template>
                  <template v-else-if="subMenus.customSubmenuTwo">
                    <li class="submenu submenu-two">
                      <a
                        href="javascript:void(0);"
                        @click="openSubmenuOne(subMenus)"
                        :class="{ subdrop: openSubmenuOneItem === subMenus }"
                      >
                        {{ subMenus.menuValue }}
                        <span class="menu-arrow inside-submenu"></span>
                      </a>
                      <ul
                        class="submenu-list nested"
                        :class="{ show: openSubmenuOneItem === subMenus }"
                      >
                        <li
                          v-for="subMenuTwo in subMenus.subMenusTwo"
                          :key="subMenuTwo.menuValue"
                        >
                          <router-link
                            :to="subMenuTwo.route"
                            @click="handleNavClick"
                          >{{
                            subMenuTwo.menuValue
                          }}</router-link>
                        </li>
                      </ul>
                    </li>
                  </template>
                </li>
              </ul>
            </li>
          </template>
        </ul>
      </li>
    </template>
  </ul>
</template>

<script>
import sideBarData from "@/assets/json/sidebar.json";
import { getCurrentUser } from "@/services/authService";

export default {
  data() {
    return {
      sideBarData: sideBarData,
      route_array: [],
      openMenuItem: null,
      openSubmenuOneItem: null,
    };
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    currentRole() {
      const payload = getCurrentUser();
      return payload?.role || null;
    },
    filteredMenu() {
      const role = this.currentRole;
      return this.sideBarData
        .map((group) => {
          const menuItems = (group.menu || []).filter((menu) =>
            this.isRoleAllowed(menu.roles, role)
          );
          if (!this.isRoleAllowed(group.roles, role)) {
            return null;
          }
          return {
            ...group,
            menu: menuItems,
          };
        })
        .filter((group) => group && group.menu.length > 0);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.updateRouteArray();
        this.ensureActiveMenuVisible();
      },
    },
  },
  methods: {
    collapseAllSubmenus() {
      // Reset Vue-backed submenu state
      this.sideBarData.forEach((group) => {
        (group.menu || []).forEach((menu) => {
          if (typeof menu.showSubRoute !== "undefined") {
            menu.showSubRoute = false;
          }
        });
      });
      this.openMenuItem = null;
      this.openSubmenuOneItem = null;
    },
    isMenuActive(menu) {
      const path = this.$route.path;
      if (menu.route && menu.route === path) return true;
      if (menu.active_link && this.route_array[1] === menu.active_link) return true;

      if (menu.hasSubRoute && Array.isArray(menu.subMenus)) {
        const match = menu.subMenus.some(
          (sub) =>
            sub.route === path ||
            sub.active_link === path ||
            (sub.route && path.startsWith(sub.route + "/"))
        );
        if (match) return true;
      }

      if (menu.hasSubRouteTwo && Array.isArray(menu.subMenus)) {
        const match = menu.subMenus.some((sub) => {
          if (sub.customSubmenuTwo && Array.isArray(sub.subMenusTwo)) {
            return sub.subMenusTwo.some(
              (sub2) =>
                sub2.route === path ||
                sub2.active_link === path ||
                (sub2.route && path.startsWith(sub2.route + "/"))
            );
          }
          return (
            sub.route === path ||
            sub.active_link === path ||
            (sub.route && path.startsWith(sub.route + "/"))
          );
        });
        if (match) return true;
      }
      return false;
    },
    ensureActiveMenuVisible() {
      const path = this.$route.path;
      const body = typeof document !== "undefined" ? document.body : null;
      const isMini = body?.classList?.contains("mini-sidebar");

      let menuToOpen = null;
      let nestedToOpen = null;

      this.sideBarData.forEach((group) => {
        (group.menu || []).forEach((menu) => {
          // Level 1 submenu (hasSubRoute)
          if (menu.hasSubRoute && Array.isArray(menu.subMenus)) {
            const match = menu.subMenus.find(
              (sub) =>
                sub.route === path ||
                sub.active_link === path ||
                (sub.route && path.startsWith(sub.route + "/"))
            );
            menu.showSubRoute = !!match && !isMini;
            if (menu.showSubRoute) {
              menuToOpen = menu;
            }
          }

          // Level 2 submenu (hasSubRouteTwo + customSubmenuTwo)
          if (menu.hasSubRouteTwo && Array.isArray(menu.subMenus)) {
            const matchSub = menu.subMenus.find((sub) => {
              if (sub.customSubmenuTwo && Array.isArray(sub.subMenusTwo)) {
                return sub.subMenusTwo.some(
                  (sub2) =>
                    sub2.route === path ||
                    sub2.active_link === path ||
                    (sub2.route && path.startsWith(sub2.route + "/"))
                );
              }
              return (
                sub.route === path ||
                sub.active_link === path ||
                (sub.route && path.startsWith(sub.route + "/"))
              );
            });

            if (matchSub && !isMini) {
              menuToOpen = menu;
              nestedToOpen = matchSub.customSubmenuTwo ? matchSub : null;
            }
          }
        });
      });

      if (isMini) {
        this.collapseAllSubmenus();
      } else {
        this.openMenuItem = menuToOpen || null;
        this.openSubmenuOneItem = nestedToOpen || null;
      }
    },
    isRoleAllowed(roles, role) {
      if (!roles || roles.length === 0) {
        return true;
      }
      if (!role) {
        return false;
      }
      const normalizedRole = String(role).toLowerCase();
      return roles.some((allowed) => String(allowed).toLowerCase() === normalizedRole);
    },
    expandSubMenus(menu) {
      this.sideBarData.forEach((item) => {
        item.menu.forEach((subMenu) => {
          if (subMenu !== menu) {
            subMenu.showSubRoute = false;
          }
        });
      });
      menu.showSubRoute = !menu.showSubRoute;
    },
    updateRouteArray() {
      this.route_array = this.$route.path.split("/");
    },
    openMenu(menu) {
      this.openMenuItem = this.openMenuItem === menu ? null : menu;
    },
    openSubmenuOne(subMenus) {
      this.openSubmenuOneItem =
        this.openSubmenuOneItem === subMenus ? null : subMenus;
    },
    handleNavClick() {
      if (typeof window === "undefined") return;
      const body = document.body;
      if (window.innerWidth <= 1024) {
        document.body.classList.remove("slide-nav", "menu-opened");
      }
      if (body.classList.contains("mini-sidebar")) {
        body.classList.remove("expand-menu");
        this.collapseAllSubmenus();
      }
    },
  },
  mounted() {
    window.addEventListener("collapse-side-menus", this.collapseAllSubmenus);
    this.ensureActiveMenuVisible();
  },
  beforeUnmount() {
    window.removeEventListener("collapse-side-menus", this.collapseAllSubmenus);
  },
};
</script>

<style scoped>
.submenu-list {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.25s ease, opacity 0.2s ease;
}

.submenu-list.show {
  max-height: 500px;
  opacity: 1;
}

.submenu-list.nested {
  padding-left: 12px;
}
</style>
